import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTable: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTable"><Path d="M10.5 3H21V9H10.5V3Z" fill="currentColor"/><Path d="M9 3H3V9H9V3Z" fill="currentColor"/><Path d="M3 10.5V21H9V10.5H3Z" fill="currentColor"/><Path d="M10.5 21H21V10.5H10.5V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTable;
